import { queryOptions } from "@tanstack/react-query";

import { blastFiringAjax } from "../../ajax/BlastFiringAjax";
import { blastMonitorsAjax } from "../../ajax/BlastMonitorsAjax";
import { blastPatternAjax } from "../../ajax/BlastPatternAjax";
import { ErrorResponse } from "../../DTOs/Common/ErrorResponse";
import { BlastFiringRecordDTO, PatternFragmentationDTO } from "../../DTOs/DrillBlast/FiringDTO";
import { BlastMonitorDTO, PatternMonitoringDTO } from "../../DTOs/DrillBlast/MonitoringDTO";
import { PatternDetailDTO } from "../../DTOs/DrillBlast/PatternLifecycleDTO";

export const patternQuery = (patternId: number) => queryOptions({
  queryKey: ['drillBlast', 'pattern', patternId],
  queryFn: async (): Promise<PatternDetailDTO> => {
    const res = await blastPatternAjax.getPattern(patternId);
    if (ErrorResponse.isErrorResponse(res)) throw new Error('Failed to load the blast pattern');
    return res;
  },
});

export const firingRecordQuery = (patternId: number) => queryOptions({
  queryKey: ['drillBlast', 'firing', patternId],
  queryFn: async (): Promise<BlastFiringRecordDTO> => {
    const res = await blastFiringAjax.getRecord(patternId);
    if (ErrorResponse.isErrorResponse(res)) throw new Error('Failed to load the firing record');
    return res;
  },
});

export const fragmentationQuery = (patternId: number) => queryOptions({
  queryKey: ['drillBlast', 'fragmentation', patternId],
  queryFn: async (): Promise<PatternFragmentationDTO> => {
    const res = await blastFiringAjax.getFragmentation(patternId);
    if (ErrorResponse.isErrorResponse(res)) throw new Error('Failed to load the fragmentation surveys');
    return res;
  },
});

export const monitoringQuery = (patternId: number) => queryOptions({
  queryKey: ['drillBlast', 'monitoring', patternId],
  queryFn: async (): Promise<PatternMonitoringDTO> => {
    const res = await blastFiringAjax.getMonitoring(patternId);
    if (ErrorResponse.isErrorResponse(res)) throw new Error('Failed to load the monitoring readings');
    return res;
  },
});

export const blastMonitorsQuery = queryOptions({
  queryKey: ['drillBlast', 'monitorOptions'],
  queryFn: async (): Promise<BlastMonitorDTO[]> => {
    const res = await blastMonitorsAjax.getMonitors();
    if (ErrorResponse.isErrorResponse(res)) throw new Error('Failed to load the monitors');
    return res.data;
  },
});
